import { useState } from 'react';
import { CustomSelector, DragDropImageUploader, type SelectorOption } from '..';
import { isUrl } from '../../../tools';

const UPLOAD_IMAGE_VALUE = 'UPLOAD_IMAGE_VALUE';
interface ImageUrlSelectorProps {
    url?: string;
    setIsImageLoading: (isLoading: boolean) => void;
    onChange: (url: string | undefined) => void;
    selectorOptions?: SelectorOption[];
    allowedFileTypes?: string[];
}

const SELECTOR_DATA: SelectorOption[] = [
    {
        label: 'Upload Image',
        value: UPLOAD_IMAGE_VALUE,
    },
];

export const ImageUrlSelector = ({
    url,
    setIsImageLoading,
    onChange,
    selectorOptions,
    allowedFileTypes,
}: ImageUrlSelectorProps) => {
    const [isUploading, setIsUploading] = useState(false);
    const [showImageUploader, setShowImageUploader] = useState(false);

    const selectorData =
        selectorOptions && selectorOptions.length ? [...SELECTOR_DATA, ...selectorOptions] : SELECTOR_DATA;

    const handleUploadingStateChange = (uploading: boolean) => {
        setIsUploading(uploading);
        setIsImageLoading(uploading);
    };
    const onSelectChange = (selectedValue?: string) => {
        if (selectedValue === UPLOAD_IMAGE_VALUE) {
            onChange(undefined);
            setShowImageUploader(true);
        } else {
            onChange(selectedValue);
            setShowImageUploader(false);
        }
    };

    return (
        <>
            <CustomSelector
                selectorLabel="URL"
                textfieldLabel="URL"
                data={selectorData}
                value={url}
                setValue={onSelectChange}
                validator={isUrl}
                isLoading={isUploading}
            />
            {showImageUploader && (
                <DragDropImageUploader
                    allowedFileTypes={allowedFileTypes}
                    onUploadingStateChange={handleUploadingStateChange}
                    onChange={onChange}
                    onClear={() => onChange(undefined)}
                />
            )}
        </>
    );
};
